// Video URL utilities for handling different video platforms
export const convertToEmbedUrl = (url) => {
  if (!url) return null;
  
  try {
    const urlObj = new URL(url);
    
    // YouTube URLs
    if (urlObj.hostname.includes('youtube.com') || urlObj.hostname.includes('youtu.be')) {
      let videoId = '';
      
      if (urlObj.hostname.includes('youtu.be')) {
        // youtu.be format: https://youtu.be/VIDEO_ID
        videoId = urlObj.pathname.slice(1);
      } else if (urlObj.hostname.includes('youtube.com')) {
        // youtube.com format: https://www.youtube.com/watch?v=VIDEO_ID
        videoId = urlObj.searchParams.get('v');
      }
      
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }
    
    // Vimeo URLs
    if (urlObj.hostname.includes('vimeo.com')) {
      const videoId = urlObj.pathname.slice(1);
      if (videoId) {
        return `https://player.vimeo.com/video/${videoId}`;
      }
    }
    
    // Dailymotion URLs
    if (urlObj.hostname.includes('dailymotion.com')) {
      const videoId = urlObj.pathname.split('/').pop();
      if (videoId) {
        return `https://www.dailymotion.com/embed/video/${videoId}`;
      }
    }
    
    // Wistia URLs
    if (urlObj.hostname.includes('wistia.com')) {
      const videoId = urlObj.pathname.split('/').pop();
      if (videoId) {
        return `https://fast.wistia.com/embed/medias/${videoId}`;
      }
    }
    
    // If it's already an embed URL, return as is
    if (url.includes('/embed/')) {
      return url;
    }
    
    // For other URLs, return as is (might work with some platforms)
    return url;
    
  } catch (error) {
    return url; // Return original URL if conversion fails
  }
};

export const getVideoThumbnail = (url) => {
  if (!url) return null;
  
  try {
    const urlObj = new URL(url);
    
    // YouTube thumbnail
    if (urlObj.hostname.includes('youtube.com') || urlObj.hostname.includes('youtu.be')) {
      let videoId = '';
      
      if (urlObj.hostname.includes('youtu.be')) {
        videoId = urlObj.pathname.slice(1);
      } else if (urlObj.hostname.includes('youtube.com')) {
        videoId = urlObj.searchParams.get('v');
      }
      
      if (videoId) {
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
      }
    }
    
    // Vimeo thumbnail (requires API call, returning placeholder)
    if (urlObj.hostname.includes('vimeo.com')) {
      return 'https://via.placeholder.com/1280x720/000000/FFFFFF?text=Vimeo+Video';
    }
    
    return null;
  } catch (error) {
    return null;
  }
};

export const isValidVideoUrl = (url) => {
  if (!url) return false;
  
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    
    return (
      hostname.includes('youtube.com') ||
      hostname.includes('youtu.be') ||
      hostname.includes('vimeo.com') ||
      hostname.includes('dailymotion.com') ||
      hostname.includes('wistia.com') ||
      hostname.includes('vimeo.com')
    );
  } catch (error) {
    return false;
  }
};

export const getVideoPlatform = (url) => {
  if (!url) return 'unknown';
  
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    
    if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
      return 'youtube';
    } else if (hostname.includes('vimeo.com')) {
      return 'vimeo';
    } else if (hostname.includes('dailymotion.com')) {
      return 'dailymotion';
    } else if (hostname.includes('wistia.com')) {
      return 'wistia';
    }
    
    return 'unknown';
  } catch (error) {
    return 'unknown';
  }
};
